import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa'; // Importing the search icon from react-icons

// Styled components for the search bar (retaining existing styles)
const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SearchForm = styled.form`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 600px;
  background-color: #f8f8f8;
  padding: 10px;
  border-radius: 30px;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 30px;
  outline: none;
  font-size: 16px;
`;

const SearchButton = styled.button`
  background-color: transparent;
  border: none;
  margin-left: -40px;
  cursor: pointer;
  color: #333;
  font-size: 16px;

  &:hover {
    color: #4CAF50;
  }
`;
// New styled components for the modal
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 400px;
  width: 100%;
`;

const ModalTitle = styled.h2`
  margin-top: 0;
  color: #333;
`;

const ModalDescription = styled.p`
  color: #666;
`;

const ModalButton = styled.button`
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 10px;

  &:hover {
    background-color: #45a049;
  }
`;


const SearchBar = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    if (searchQuery.trim() !== '') {
      try {
        const response = await fetch(`/api/search/?query=${searchQuery}`);
        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
  
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const data = await response.json();
  
          if (data.categories.length > 0) {
            const categorySlug = data.categories[0].slug;
            navigate(`/categories/${categorySlug}`);
          } 
          else if (data.products.length > 0) {
            const productSlug = data.products[0].slug;
            navigate(`/product/${productSlug}`);
          } else {
            setShowModal(true);
          }
        } else {
          throw new Error('Response is not in JSON format');
        }
      } catch (error) {
        console.error('Search error:', error);
        setShowModal(true);
      }
    }
  };

  return (
    <>
      <SearchContainer>
        <SearchForm onSubmit={handleSearchSubmit}>
          <SearchInput 
            type="text" 
            placeholder="Search for Halal Meats..." 
            value={searchQuery} 
            onChange={(e) => setSearchQuery(e.target.value)} 
          />
          <SearchButton type="submit">
            <FaSearch size={16} />
          </SearchButton>
        </SearchForm>
      </SearchContainer>

      {showModal && (
        <ModalOverlay>
          <ModalContent>
            <ModalTitle>No Results Found</ModalTitle>
            <ModalDescription>
              We couldn't find any products or categories matching your search query.
            </ModalDescription>
            <ModalButton onClick={() => setShowModal(false)}>Okay</ModalButton>
          </ModalContent>
        </ModalOverlay>
      )}
    </>
  );
};

export default SearchBar;